import { defineMessages } from 'react-intl';

export const appleIapMessages = defineMessages({
  manageAccount: {
    defaultMessage: 'Visit heidihealth.com to manage your account.',
    id: '+XPIZzpKUe',
    description:
      'Info-only text shown to users on Apple-compliant builds where upgrade/billing CTAs are suppressed. Directs them to the website to manage their subscription. Note: the domain heidihealth.com is intentionally embedded in this string and must be updated across all locale translations if the brand domain changes.',
  },
});
